import { useTranslation } from 'react-i18next';

export function AboutSection() {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="py-16 sm:py-20 md:py-24">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center max-w-5xl mx-auto">
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-extralight text-white mb-6 sm:mb-8 leading-tight tracking-[0.05em] px-2">
            <span className="bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">{t('aboutTitle')}</span>{t('aboutTitleSuffix')}
          </h3>
          <p className="text-gray-400 text-base sm:text-lg md:text-xl leading-relaxed font-light max-w-4xl mx-auto px-4">
            {t('aboutDescription')}
          </p>
        </div>
      </div>
    </section>
  );
}
